"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addSubtypeToMembers = exports.createGuestsFromRecipients = void 0;
const helpers_1 = require("@/app/shared/helpers");
const uuid_1 = require("uuid");
/**
 * Create CUSTOM guests from Gmail/Outlook recipients
 */
const createGuestsFromRecipients = (recipientsEmails) => {
    if (!recipientsEmails) {
        return { mainGuest: null, guests: [] };
    }
    const { TO = [], CC = [], BCC = [] } = recipientsEmails;
    const contacts = [...TO, ...CC, ...BCC];
    if (!contacts.length) {
        return { mainGuest: null, guests: [] };
    }
    // Deduplicate emails
    const emails = contacts.map((g) => g.emailAddress);
    const uniqueEmails = Array.from(new Set(emails));
    const uniqueGuests = uniqueEmails.map((email) => contacts.find((guest) => guest.emailAddress === email));
    // Create CUSTOM contacts
    const [first, ...other] = uniqueGuests;
    const mainGuest = first
        ? {
            id: (0, uuid_1.v4)(),
            type: "CUSTOM" /* MemberType.CUSTOM */,
            subType: "CONTACT" /* MemberSubType.CONTACT */,
            email: first.emailAddress,
            name: first.name,
        }
        : null;
    const guests = other.map((contact) => ({
        id: (0, uuid_1.v4)(),
        type: "CUSTOM" /* MemberType.CUSTOM */,
        subType: "CONTACT" /* MemberSubType.CONTACT */,
        email: contact?.emailAddress,
        name: contact?.name,
    }));
    return { mainGuest, guests };
};
exports.createGuestsFromRecipients = createGuestsFromRecipients;
/**
 * Add subtype to integration members
 */
const addSubtypeToMembers = (membersList) => {
    return membersList.map((member) => {
        if (member.type === "SUMO1" /* MemberType.SUMO1 */ && member.subType) {
            return member;
        }
        return {
            ...member,
            integration: (0, helpers_1.getIntegration)(member),
        };
    });
};
exports.addSubtypeToMembers = addSubtypeToMembers;
